
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aboutUs",
      function () {
        return require("private-next-pages/aboutUs.js");
      }
    ]);
  